import { render, staticRenderFns } from "./Gallary.vue?vue&type=template&id=79c9d26a"
import script from "./Gallary.vue?vue&type=script&lang=js"
export * from "./Gallary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports